export const version = "wallet/5.0.12";
//# sourceMappingURL=_version.js.map